import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { withRoomContext } from '../../../RoomContext';
import * as settingsActions from '../../../actions/settingsActions';
import * as roomActions from '../../../actions/roomActions';
import StatusView from './StatusView';
import TeamToolView from './TeamToolView';
import Icons from '../Common/Icons';

import Box from '@material-ui/core/Box';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import OnMemoDialog from './OnMemoDialog';

// Const
import { MEMO_TEMP, ROOM_OFFLINE, ROOM_ONLINE, ROOM_CALLING, ROOM_TALKING } from '../../../const';

const styles = () =>
	({
		root :
		{
			height          : '100%',
			width           : '100%',
			aspectRatio     : 1.777,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			overflow        : 'auto'
		},
		leftArea :
		{
			width  : '80%',
			height : '100'
		},
		rightArea :
		{
			width          : '20%',
			height         : '100%',
			justifyContent : 'center',
			alignItems     : 'flex-start',
			display        : 'flex',
			textAlign      : 'left',
			zIndex         : '1'
		},

		leftTopSection :
		{
			width   : '100%',
			height  : '75%',
			display : 'flex'
		},

		leftBottomSection :
		{
			marginTop      : '2%',
			width          : '100%',
			height         : '25%',
			display        : 'flex',
			justifyContent : 'end'
		},
		memoArea :
		{
			width      : '25%',
			height     : '100%',
			alignItems : 'flex-start',
			display    : 'flex'
		},
		roomInfoArea :
		{
			width      : '72.5%',
			height     : '100%',
			alignItems : 'center',
			margin     : '0 1%'
		},
		mainArea :
		{
			width   : '100%',
			display : 'flex',
			height  : '100%'
		},
		statusLogo :
		{
			width        : '5rem',
			marginBottom : '3%'
		},
		statusMessage :
		{
			fontSize     : '1.5rem',
			fontWeight   : '200',
			color        : '#adadac',
			marginBottom : '5%'
		},
		statusControl :
		{
			width          : '12rem',
			display        : 'flex',
			justifyContent : 'space-between'
		},
		userStatus :
		{
			height         : '100%',
			marginBottom   : '2%',
			justifyContent : 'center',
			alignItems     : 'start',
			display        : 'flex'
		},
		roomStatus :
		{
			maxWidth     : '750px',
			width        : '100%',
			marginBottom : '2%'
		},
		roomStatusBg :
		{
			position      : 'absolute',
			marginTop     : '4rem',
			width         : '95%',
			borderBottom  : '2px solid #bdbdbb',
			color         : '#b3b4b2',
			fontSize      : '1.2rem',
			fontWeight    : 'bold',
			paddingBottom : '0.5rem',
			bottom        : '12%'
		},
		roomList :
		{
			display        : 'flex',
			justifyContent : 'flex-start',
			alignSelf      : 'center',
			zIndex         : '1'
		},
		roomUser :
		{
			background     : '#999898',
			border         : '1px solid transparent',
			height         : '13vh',
			width          : '13vh',
			borderRadius   : '0.5rem',
			boxShadow      : '2px 0px 3px #aaa',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'start',
			paddingTop     : '5%'
		},
		roomUserNormal :
		{
			height : '13vh',
			width  : '13vh'
		},
		roomUserPaginate : {
			height : '13vh',
			width  : '12.5vh'
		},
		roomUserAvatar :
		{
			justifyContent : 'center',
			display        : 'flex',
			marginBottom   : '0.5rem'
		},
		avatar :
		{
			width              : '2.5rem',
			height             : '2.5rem',
			backgroundColor    : '#fff',
			padding            : '2%',
			'& .MuiAvatar-img' :
			{
				objectFit : 'contain'
			}
		},
		roomUserStatus :
		{

		},
		roomUserName :
		{
			fontSize     : '1rem',
			color        : 'white',
			marginBottom : '0.5rem'
		},
		roomAction :
		{
			padding : '0 15%'
		},
		inviteBtn :
		{
			backgroundColor : 'white',
			borderRadius    : '0.3rem',
			border          : '1px solid white',
			padding         : '0.1rem 0',
			'&:hover'       : {
				cursor : 'pointer'
			}
		},
		roomNo :
		{
			border               : 'none',
			borderTopLeftRadius  : '0.5rem',
			borderTopRightRadius : '0.5rem',
			color                : 'white',
			backgroundColor      : '#808080',
			boxShadow            : '2px 0px 3px #aaa',
			margin               : '0 15px'
		},
		roomNoMe :
		{
			backgroundColor : '#fff',
			color           : '#808080'
		},
		roomAnimation :
		{
			animation : '$flash 1s linear infinite'
		},
		'@keyframes flash' : {
			'0%'   : { backgroundColor: '#FFA500' },
			'50%'  : { backgroundColor: '#D88900' },
			'100%' : { backgroundColor: '#FFA500' }
		},
		statusBg :
		{

		},
		statusBgWaiging :
		{
			backgroundColor : '#9ec317'
		},
		statusBgTalking :
		{
			backgroundColor : '#e26b04'
		},
		memoList :
		{
			height         : '100%',
			width          : '100%',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'flex-start',
			padding        : '2%',
			overflow       : 'auto'
		},
		memoListItem :
		{
			backgroundColor : '#fff',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.5rem',
			display         : 'flex',
			flexDirection   : 'column',
			justifyContent  : 'space-between',
			marginBottom    : '5%',
			'& :hover'      :
			{
				cursor  : 'pointer',
				opacity : 0.8
			}
		},
		memoListItemHeader :
		{
			height               : '0.8rem',
			backgroundColor      : '#919191',
			borderTopRightRadius : '0.5rem',
			borderTopLeftRadius  : '0.5rem'
		},
		memoListItemHeaderActive :
		{
			height               : '0.8rem',
			backgroundColor      : '#9ec317',
			borderTopRightRadius : '0.5rem',
			borderTopLeftRadius  : '0.5rem'
		},
		memoListItemContent :
		{
			display        : 'flex',
			justifyContent : 'center',
			padding        : '4% 5%',
			fontSize       : '0.8rem'
		},
		memoEditTitle :
		{
			textAlign : 'center'
		},
		memoListItemDate :
		{
			width          : '80%',
			borderBottom   : '1px solid #999898',
			color          : '#999898',
			display        : 'flex',
			justifyContent : 'space-between'
		},
		memoEdit :
		{
			width           : '100%',
			height          : '100%',
			backgroundColor : '#fff',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.5rem',
			display         : 'flex',
			flexDirection   : 'column',
			justifyContent  : 'space-between'
		},
		memoEditContent :
		{
			padding : '5% 0',
			height  : '100%'
		},
		roomsArea :
		{
			width          : '100%',
			position       : 'relative',
			margin         : '0 42px 0 42px',
			display        : 'flex',
			justifyContent : 'center'
		},
		roomsList5 :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'space-between'
		},
		roomsListUnder5 :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'start'
		},
		paginationBox :
		{
			position  : 'absolute',
			height    : '42px',
			width     : '42px',
			marginTop : '3.75vh',
			zIndex    : '3'
		},
		paginationBoxLeft :
		{
			top  : '0',
			left : '-42px'
		},
		paginationBoxRight :
		{
			top   : '0',
			right : '-42px'
		},
		paginationIcon :
		{
			color      : '#999898',
			fontSize   : '3rem !important',
			fontWeight : 'bold',
			cursor     : 'pointer',
			zIndex     : '3',
			'&:hover'  :
			{
				color : '#666565'
			}
		},
		firstPageRoomList : {
			marginLeft : '44px'
		},
		roomInfoPaginate :
		{
			justifyContent : 'start',
			display        : 'flex',
			flexDirection  : 'column',
			textAlign      : 'center',
			zIndex         : '1'
		},
		roomInfoPaginate5 :
		{
			margin : '0 1%'
		},
		roomInfoPaginateUnder5 :
		{
			margin : '0 2% 0 1%'
		},
		centeredRoomsArea :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'center'
		},
		centeredRoomsWrapper :
		{
			marginRight : '3.8%',
			zIndex      : '1',
			display     : 'inline-flex'
		},
		roomInfoCentered :
		{
			justifyContent : 'start',
			display        : 'flex',
			flexDirection  : 'column',
			textAlign      : 'center',
			zIndex         : 1,
			margin         : '0 10px'
		}
	});

const HomeWaitingView = ({
	classes,
	rooms,
	room,
	roomClient,
	memos,
	memo,
	setMemo
}) =>
{
	const [ tempMemos, setTempMemos ] = useState([]);
	const [ page, setPage ] = useState(1);
	const [ roomsToShow, setRoomsToShow ] = useState([]);
	const [ roomsStatus, setRoomsStatus ] = useState({
		waitingRooms : 0,
		callingRooms : 0
	});

	const [ tab, setTab ] = useState(0);

	const changeTab = (event, newValue) =>
	{
		setTab(newValue);
	};

	const inviteRoom = useCallback((roomId) =>
	{
		roomClient.sendInvite(room.name, roomId);
	}, [ room, roomClient ]);

	useEffect(() =>
	{
		const list = memos.filter((item) =>
			(item.status === MEMO_TEMP
				&& (item.roomId === undefined || item.roomId === room.name)));

		setTempMemos(list);
	}, [ memos, room ]);

	const selectMemo = useCallback((item) =>
	{
		if (room.info?.status !== ROOM_TALKING)
		{
			setMemo(item);
			setTab(1);
		}
	}, [ setMemo, room.info ]);

	useEffect(() =>
	{

		let pageNum = page;

		// no item to show => back to page 1
		if (rooms.length <= (page-1)*5)
		{
			pageNum = 1;
		}

		const roomsAr = [];

		for (let i = 0; i<5; i++)
		{
			const roomIndex = i + (pageNum-1)*5;

			if (rooms[roomIndex])
			{
				roomsAr.push(
					{
						...rooms[roomIndex],
						roomNumber : roomIndex + 1
					});
			}
		}

		setRoomsToShow(roomsAr);

	}, [ rooms, page ]);

	useEffect(() =>
	{
		let waitingRooms = 0;

		let callingRooms = 0;

		rooms.forEach((r) =>
		{
			if (r.status === ROOM_ONLINE || r.status === ROOM_CALLING)
			{
				waitingRooms += 1;
			}
			else if (r.status === ROOM_TALKING)
			{
				callingRooms += 1;
			}
		});

		setRoomsStatus({
			waitingRooms : waitingRooms,
			callingRooms : callingRooms
		});

	}, [ rooms ]);

	const pageForward = () =>
	{
		setPage((state) =>
		{

			// forward after last page
			if (state + 1 > Math.ceil(rooms.length/5))
			{
				// first page
				return 1;
			}
			else
			{
				return state + 1;
			}
		});
	};

	const pageBack = () =>
	{
		setPage((state) =>
		{
			// back before page1
			if (state -1 < 1)
			{
				// final page
				return Math.ceil(rooms.length/5);
			}
			else
			{
				return state - 1;
			}
		});
	};

	const getDateString = (timestamp) =>
	{
		const date = timestamp ? new Date(timestamp) : new Date();
		const month = (`0${date.getMonth() + 1}`).slice(-2);
		const day = (`0${date.getDate()}`).slice(-2);
		const hour = (`0${date.getHours()}`).slice(-2);
		const min = (`0${date.getMinutes()}`).slice(-2);

		return `${date.getFullYear()}/${month}/${day} ${hour}:${min}`;
	};

	// change css depends on conditions
	let firstPageRoolListClass = '';

	if (page === 0 && rooms.length > 5)
	{
		firstPageRoolListClass = classes.firstPageRoomList;
	}

	let roomsListCss = classes.roomsList5;

	let roomInfoPaginateCss = classes.roomInfoPaginate5;

	if (roomsToShow.length < 5)
	{
		roomsListCss = classes.roomsListUnder5;
		roomInfoPaginateCss = classes.roomInfoPaginateUnder5;
	}

	return (
		<div className={classes.root}>
			<div className={classes.mainArea}>
				<div className={classes.leftArea}>
					<div className={classes.leftTopSection}>
						<div className={classes.memoArea}>
							<div className={classes.memoList}>
								{tempMemos.length > 0 &&
							tempMemos.map((item, index) =>
								(
									<div
										className={classes.memoListItem}
										key={index}
										onClick={() => selectMemo(item)}
									>
										<div className={
											(memo && memo.id === item.id) ?
												classes.memoListItemHeaderActive : classes.memoListItemHeader
										}
										/>
										<div className={classes.memoListItemContent}>
											<div className={classes.memoListItemDate}>
												<span>日付</span>
												<span>{getDateString(item.timestamp)}</span>
											</div>
											<ArrowRightIcon />
										</div>
									</div>
								)
							)}
							</div>
						</div>
						<div className={classes.roomInfoArea}>
							<div className={classes.userStatus}>
								<StatusView roomsStatus={roomsStatus}/>
							</div>
						</div>
					</div>
					<div className={classes.leftBottomSection}>
						<div className={classes.roomStatus}>
							<div className={`${classes.roomList} ${firstPageRoolListClass}`}>

								{roomsToShow.length < 1 ? (
									<div>no items</div>
								) : <>
									{rooms.length <= 5 ? // 1-5 rooms
										<div className={classes.centeredRoomsArea}>
											<div className={classes.centeredRoomsWrapper}>
												{roomsToShow.map((item, index) =>
													(<div className={classes.roomInfoCentered} key={index}>
														<div className={
															classnames(
																classes.roomNo,
																item.status === ROOM_CALLING ? classes.roomAnimation :
																	item.id === room.name ? classes.roomNoMe : null
															)}
														>
															room.{item.roomNumber}
														</div>
														<div
															className={
																classnames(
																	classes.roomUser, classes.roomUserNormal,
																	item.status === ROOM_ONLINE ?
																		classes.statusBgWaiging
																		: null,
																	item.status === ROOM_CALLING ?
																		classes.statusBgWaiging
																		: null,
																	item.status === ROOM_TALKING
																		? classes.statusBgTalking
																		: null
																)
															}
														>
															<div className={classes.roomUserAvatar}>
																<Avatar
																	alt={item.user}
																	src='images/icon_host_status.svg'
																	className={classes.avatar}
																>
																	<Icons category={'host'} iconName={'status'} type={'normal'} size={'3rem'}/>
																</Avatar>
															</div>
															<div className={classes.roomUserName}>
																{item.status === ROOM_OFFLINE ?
																	'オフライン'
																	:
																	item.user
																}
															</div>
															<div className={classes.roomAction}>
																{ (item.status === ROOM_ONLINE
																&& item.id !== room.name
																&& item.status === 99999) &&
																<div
																	className={classes.inviteBtn}
																	onClick={() => inviteRoom(item.id)}
																>
																	▶呼び出し
																</div>
																}
															</div>
														</div>
													</div>)
												)
												}
											</div>
										</div>
										: // more than 5 rooms
										<div className={classes.roomsArea}>
											<Box
												aria-label='before'
												className={`${classes.paginationBox} ${classes.paginationBoxLeft}`}
											>
												<NavigateBeforeIcon
													className={classes.paginationIcon}
													onClick={pageBack}
												/>
											</Box>
											<Box className={roomsListCss}>
												{roomsToShow.map((item, index) =>
													(<div className={`${classes.roomInfoPaginate} ${roomInfoPaginateCss}`} key={index}>
														<div className={
															classnames(
																classes.roomNo,
																item.status === ROOM_CALLING ? classes.roomAnimation :
																	item.id === room.name ? classes.roomNoMe : null
															)}
														>
															room.{item.roomNumber}
														</div>
														<div
															className={
																classnames(
																	classes.roomUser, classes.roomUserPaginate,
																	item.status === ROOM_ONLINE ?
																		classes.statusBgWaiging
																		: null,
																	item.status === ROOM_CALLING ?
																		classes.statusBgWaiging
																		: null,
																	item.status === ROOM_TALKING
																		? classes.statusBgTalking
																		: null
																)
															}
														>
															<div className={classes.roomUserAvatar}>
																<Avatar
																	alt={item.user}
																	src='images/icon_host_status.svg'
																	className={classes.avatar}
																>
																	<Icons category={'host'} iconName={'status'} type={'normal'} size={'3rem'}/>
																</Avatar>
															</div>
															<div className={classes.roomUserName}>
																{item.status === ROOM_OFFLINE ?
																	'オフライン'
																	:
																	item.user
																}
															</div>
															<div className={classes.roomAction}>
																{ (item.status === ROOM_ONLINE
																	&& item.id !== room.name) &&
																	<div
																		className={classes.inviteBtn}
																		onClick={() => inviteRoom(item.id)}
																	>
																		▶呼び出し
																	</div>
																}
															</div>
														</div>
													</div>)
												)
												}
											</Box>
											<Box
												aria-label='next'
												className={`${classes.paginationBox} ${classes.paginationBoxRight}`}
											>
												<NavigateNextIcon
													className={classes.paginationIcon}
													onClick={pageForward}
												/>
											</Box>
										</div>}
								</>
								}
							</div>
						</div>
					</div>
				</div>
				<div className={classes.rightArea}>
					<TeamToolView tab={tab} changeTab={changeTab}/>
				</div>
			</div>
			<div className={classes.roomStatusBg}>
				対応状況
			</div>
			{room.memoDialogOpen &&
				<OnMemoDialog />
			}
		</div>
	);

};

HomeWaitingView.propTypes =
{
	roomClient : PropTypes.any.isRequired,
	room       : PropTypes.object.isRequired,
	rooms      : PropTypes.array.isRequired,
	classes    : PropTypes.object.isRequired,
	memos      : PropTypes.array.isRequired,
	memo       : PropTypes.object,
	setMemo    : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room                  : state.room,
		rooms                 : state.me.rooms,
		mediaPerms            : state.settings.mediaPerms,
		memos                 : state.room.memos,
		memo                  : state.room.memo,
		displayName           : state.settings.displayName,
		displayNameInProgress : state.me.displayNameInProgress,
		loginEnabled          : state.me.loginEnabled,
		loggedIn              : state.me.loggedIn,
		locale                : state.intl.locale,
		localesList           : state.intl.list
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		changeDisplayName : (displayName) =>
		{
			dispatch(settingsActions.setDisplayName(displayName));
		},
		setMemo : (memo) =>
		{
			dispatch(roomActions.setMemo(memo));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.room.memos === next.room.memos &&
				prev.room.memo === next.room.memo &&
				prev.room.inLobby === next.room.inLobby &&
				prev.room.signInRequired === next.room.signInRequired &&
				prev.room.overRoomLimit === next.room.overRoomLimit &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.me.rooms === next.me.rooms
			);
		}
	}
)(withStyles(styles)(HomeWaitingView)));